import React from 'react';

import { FormattedMessage } from '@futrli/localisation';

import { DELETED_REFERENCE_CODE, FormulaError } from '../../../types';

import * as styles from '../formula.scss';

interface PredictionFormulaErrorProps {
  formulaContent: string;
  formulaError: { error_code: FormulaError; is_valid: boolean };
  show: boolean;
}

export const PredictionFormulaError = ({ formulaContent, formulaError, show }: PredictionFormulaErrorProps) => {
  if (!show || formulaError.is_valid) {
    return null;
  }

  return (
    <div className={styles.formulaErrorFooter}>
      {formulaError.error_code === FormulaError.ERROR_CIRCULAR_REFERENCE && (
        <FormattedMessage
          id="predict.formula_error_circular_reference"
          defaultMessage="Your formula cannot be saved, as it will create a circular reference."
        />
      )}
      {formulaError.error_code === FormulaError.ERROR_INVALID_REFERENCE && (
        <FormattedMessage
          id="predict.formula_error_invalid_reference"
          defaultMessage="Your formula cannot be saved as it contains an invalid reference."
        />
      )}
      {formulaContent.indexOf(`@${DELETED_REFERENCE_CODE}`) !== -1 && (
        <FormattedMessage
          id="predict.edit_required_account_not_valid"
          defaultMessage="Edit required - account is no longer valid."
        />
      )}
      {formulaError.error_code === FormulaError.ERROR_VALUES_OUT_OF_EXPECTED_RANGE && (
        <FormattedMessage
          id="predict.formula_error_values_out_of_expected_range"
          defaultMessage="Your formula cannot be saved, as it produces values out of expected range."
        />
      )}
      {![
        FormulaError.ERROR_CIRCULAR_REFERENCE,
        FormulaError.ERROR_INVALID_REFERENCE,
        FormulaError.ERROR_VALUES_OUT_OF_EXPECTED_RANGE
      ].includes(formulaError.error_code) &&
        formulaContent.indexOf(`@${DELETED_REFERENCE_CODE}`) === -1 && (
        <FormattedMessage
          id="predict.keep_editing_formula_not_ready"
          defaultMessage="Keep editing - your formula is not yet ready to be saved."
        />
      )}
    </div>
  );
};
